import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import { Translate } from "./Translator";
import { ConfigurationApiCheckScheduler, ConfigurationApiCRMApplicationsGetAll } from "../ExternalApi/ConfigurationApi.js";

import "../css/Main.css";
import "../css/integration.css"

//Subclasses

const CRM = () => {

    const [mFailed, SetFailed] = useState(false)
    const [mCRMApplications, SetCRMApplications] = useState([])

    useEffect(() => 
    {
        ConfigurationApiCRMApplicationsGetAll().then(result => SetCRMApplications(result)).catch(error => SetFailed(true))
    }, []);
    
    const RenderCRMApplicationsInRows = () => {
        const items = [...mCRMApplications];
        const rows = [];
      
        while (items.length) {
            rows.push(items.splice(0, 3));
        }
      
        return rows.map((row,rindex) => (
          <tr key={"crmapplicationrow" + rindex}>{row.map((crmApplication,index) => <td key={index}><img src={crmApplication.PngUrl}/> <b className="crm-header">{crmApplication.Id}</b><br/><div>{crmApplication.Description}</div><div><i>Functionality?</i></div></td>)}</tr>
        ));
    }

    if (!mCRMApplications)
    {
        if (mFailed)
        {
            return (
                <div className="loading-outer">
                    <div className="loading-inner">
                        {Translate("Failed to retrieve CRM applications")}
                    </div>
                </div>
            );      
        }
        else
        {
            return (
                <div className="loading-outer">
                    <div className="loading-inner">
                        <FontAwesomeIcon icon={faSpinner} spin /> {Translate("Loading...")}
                    </div>
                </div>
            );              
        } 
    }
    else
    {    
        return (  
                <table cellPadding="30" cellSpacing="30" align="center">
                <tbody>
                    {RenderCRMApplicationsInRows()}
                </tbody>
                </table>
        );
    }  
}

export default CRM;